import React, { FC } from 'react';
import { NotificationBanner } from './NotificationBanner';
import { ITranslate } from 'locale';
import { NavigateToFn, Route } from 'config/routes';
import { useSendEvent } from 'analytics/useSendEvent';

export enum BannerType {
  SearchSaved = 'searchSaved',
  FrequencyUpdated = 'frequencyUpdated',
}

interface BannerConfigProps {
  t: ITranslate;
  navigate: NavigateToFn;
  sendEvent: ReturnType<typeof useSendEvent>;
}

interface BannerConfigHandler {
  Component: FC<BannerConfigProps>;
  timeout?: number;
}

export const bannersConfig: Record<BannerType, BannerConfigHandler> = {
  [BannerType.SearchSaved]: ({
    Component: ({ t, navigate, sendEvent }) => (
      <NotificationBanner
        type="success"
        title={t('searchSavedBanner.title')}
        subtitle={t('searchSavedBanner.subtitle')}
        onActionClick={() => {
          navigate(Route.SavedSearchesPage, {});
          sendEvent('search_save_search_approval_click', 'search', {
            event: {
              source: 'market_place',
            },
          });
        }}
      />
    ),
    timeout: 5000,
  }),
  [BannerType.FrequencyUpdated]: ({
    Component: ({ t }) => (
      <NotificationBanner
        type="success"
        title={t('frequencyUpdatedBanner.title')}
      />
    ),
    timeout: 5000,
  }),
};
